<template>
	<div>
		<h5>FaultInformationManagement</h5>
	</div>
</template>

<script>
	export default {
		name: "FaultInformation",
	};
</script>

<style scoped></style>
